module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('svg', {
    attrs: {
      "width": "200",
      "height": "2",
      "viewBox": "0 0 200 2"
    }
  }, [_c('line', {
    staticClass: "line",
    attrs: {
      "stroke": _vm.color,
      "x1": "0",
      "y1": "1",
      "x2": "200",
      "y2": "1",
      "stroke-width": "2"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0667266","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 136
// module chunks = 1